import React from 'react';
import classNames from 'classnames';
import { IssueStatus ,IssueStatusText} from '@/utils/type';
import './index.scss'

const IssueTypeIcon = ({status}:{status: IssueStatus | 'urgent'}) => {

  return (
    <div
      className={classNames('issue-type-icon', {
        'short-green': status === IssueStatus.WAIT_ACCEPT,
        'long-green':
          status === IssueStatus.TRANSFER_WAIT_ACCEPT ||
          status === IssueStatus.DISCARD_WAIT_ACCEPT,
        'blue': status === IssueStatus.PROCESS,
        'yellow': status === IssueStatus.ON_HOLD,
        'red': status === 'urgent',
      })}
    >
        {IssueStatusText.get(status)}
    </div>
  );
};

export default React.memo(IssueTypeIcon);
